import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainChangeDeviceModule(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/changeDeviceModule/`,
    method: "post",
    params,
  });
}
